import { gql } from "@apollo/client";

export const SEND_INVOICE = gql`
  mutation sendInvoice($id: String!, $additionalMails: [String]) {
    sendInvoice(id: $id, additionalMails: $additionalMails)
  }
`;